import { render, staticRenderFns } from "./ModalForgot.vue?vue&type=template&id=ff7d5566&"
import script from "./ModalForgot.vue?vue&type=script&lang=js&"
export * from "./ModalForgot.vue?vue&type=script&lang=js&"
import style0 from "./ModalForgot.vue?vue&type=style&index=0&id=ff7d5566&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports